import type { ComponentPropsWithoutRef } from 'react';
import { startTransition } from 'react';
import { useFormStatus } from 'react-dom';
import Button from '../button/buttonUI';

type SearchSubmitProps = ComponentPropsWithoutRef<'button'> & {
  onClose: () => void;
};

const SearchSubmit = ({ children, onClose }: SearchSubmitProps) => {
  const { pending } = useFormStatus();

  const handleClick = () => {
    startTransition(() => {
      onClose();
    });
  };

  return (
    <Button disabled={pending} onClick={handleClick} type="submit">
      {children}
    </Button>
  );
};

SearchSubmit.displayName = 'SearchSubmit';

export default SearchSubmit;
